// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountSiteAccountCancelWorkflowDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': SiteAccountSiteAccountCancelWorkflowDefaultResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountSiteAccountCancelWorkflowDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "SiteAccountSiteAccountCancelWorkflowDefaultResponse"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountSiteAccountCancelWorkflowDefaultResponse.attributeTypeMap;
    }
}
